import { mockBuilder } from '../utils/builderHelper.es.js';
import { AssetComment } from './AssetComment.es.js';
import { aUser } from './User.mock.es.js';

/** @module Mocks */ /** typedoc */
function anAssetComment() {
    return mockBuilder(new AssetComment('comment-id-da816164-95d0-4ce5-b0a7-02d3ae8f68f0', 'My message', aUser(), '2017-10-17T13:56:29+00:00', '2017-10-17T13:56:29+00:00', 20000));
}

export { anAssetComment };
